import React from "react";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer, viewportOnce } from "../motionVariants";

// Every figure here is pulled directly from Shashank's resume — nothing
// estimated or rounded up for effect.
const metrics = [
    {
        value: "50,000+",
        label: "records auto-classified",
        detail: "LLM pipeline (OpenAI function calling + LangChain) catching duplicate, alternate-name, and spelling anomalies.",
    },
    {
        value: "28+ hrs/wk",
        label: "manual review eliminated",
        detail: "Direct result of the classification pipeline above, at ENTNT.",
    },
    {
        value: "60%",
        label: "less manual data entry",
        detail: "Containerized OCR pipeline for unstructured document processing.",
    },
    {
        value: "10s → 4s",
        label: "upload latency",
        detail: "Cut through architectural redesign and a caching strategy; bandwidth usage down 40%.",
    },
    {
        value: "500+",
        label: "active users served",
        detail: "Real-time content feed built on a redesigned schema, SciAstra.",
    },
    {
        value: "45%",
        label: "smaller homepage payload",
        detail: "Compression and caching cut page load from 8s to 4s, SciAstra.",
    },
];

export default function Metrics() {
    return (
        <section id="impactRoot">
            <div className="sectionHead">
                <span className="eyebrow">Engineering Impact</span>
                <h2 className="sectionTitle">Numbers, not adjectives</h2>
                <p className="sectionSub">
                    What shipping actually moved — pulled straight from the work, not rounded up.
                </p>
            </div>
            <motion.div
                id="metricsGrid"
                variants={staggerContainer}
                initial="hidden"
                whileInView="visible"
                viewport={viewportOnce}
            >
                {metrics.map((m) => (
                    <motion.div className="metricTile" key={m.label} variants={fadeInUp}>
                        <p className="metricValue">{m.value}</p>
                        <p className="metricLabel">{m.label}</p>
                        <p className="metricDetail">{m.detail}</p>
                    </motion.div>
                ))}
            </motion.div>
        </section>
    );
}
